<template>
  <section class="associate-hospital">
    <Breadcrumbs :items="breadcrumbs" />
    <rp-hospital-by-country
      v-model="model"
      :countries="countries"
      :hospitals="hospitals"
      @hospitalFound="onHospitalFound"
      @hospitalNotFound="onHospitalNotFound" />

    <h3 v-if="assignedHospitals.length > 0" class="unassociate-title">List of associated hospitals:</h3>
    <div v-for="hospital in assignedHospitals" :key="hospital.value" class="unassociate-item">
      <span>{{hospital.name}} ({{hospital.town}})</span>
      <rp-sprite name="delete_outline" @click.native="onUnassociate(hospital)"/>
    </div>

    <rp-overlay :active="showConfirm">
      <rp-confirm
        icon="warning"
        btnConfirmText="Yes"
        btnCancelText="No"
        :confirm="onConfirm"
        :cancel="onCancel"
        :messageText="hospitalRemoveMessage" />
    </rp-overlay>

    <rp-overlay :active="showOverlay">
      <rp-confirm
        icon="done"
        btnConfirmText="Yes"
        btnCancelText="No"
        :confirm="onAddAnother"
        :cancel="onAllDone"
        :messageText="hospitalAddedMessage" />
    </rp-overlay>
  </section>
</template>

<script>
  import page from '@/mixins/page'
  import Sprite from 'raypro_ui/src/components/ui/Sprite'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import HospitalByCountry from 'raypro_ui/src/components/ui/forms/HospitalLookupByCountry'

  import {mapGetters} from 'vuex'
  import {getCountries} from 'raypro_ui/src/api/countries'
  import {getHospitalsWithoutPagination} from 'raypro_ui/src/api/hospitals'
  import {getUserHospitals, addHospitalToSurgeon, removeHospitalFromSurgeon} from 'raypro_ui/src/api/users'

  export default {
    mixins: [page],

    components: {
      Breadcrumbs,
      'rp-sprite': Sprite,
      'rp-overlay': Overlay,
      'rp-confirm': Confirm,
      'rp-hospital-by-country': HospitalByCountry,
    },

    data() {
      return {
        model: {country: '', hospital: ''},
        countries: [],
        hospitals: [],
        assignedHospitals: [],
        unassignHospital: {},
        showConfirm: false,
        showOverlay: false,
        title: 'Associate Hospital',
        breadcrumbs: [{label: 'Associate Hospital'}],
      }
    },

    mounted() {
      getCountries().then(({data}) => {
        this.countries = data.map((country) => {
          return {
            id: country.id,
            name: country.name,
            code: country.code,
          }
        })
      })

      getHospitalsWithoutPagination().then(({data}) => {
        this.hospitals = data
      })

      this.getAssignedHospitals()
    },

    computed: {
      ...mapGetters(['authUser']),

      hospitalRemoveMessage() {
        if (this.unassignHospital) {
          return `Are you sure you want to remove your association with hospital '${this.unassignHospital.name}'?`
        } else {
          return "No hospital selected"
        }
      },

      hospitalAddedMessage() {
        if (this.model.hospital && this.assignedHospitals.find(x => x.id == this.model.hospital.id)) {
          return "This hospital is already associated with your user. Would you like to add another?"
        } else {
          return "Hospital added successfully. Would you like to add another?"
        }
      },
    },

    methods: {
      getAssignedHospitals() {
        getUserHospitals({id: this.authUser.id}).then(({data}) => {
          this.assignedHospitals = data
        })
      },

      onHospitalFound() {
        addHospitalToSurgeon({
          userId: this.authUser.id,
          hospitalId: this.model.hospital.id
        }).then(() => {
          this.showOverlay = true
        })
      },

      onHospitalNotFound() {
        this.$router.push({name: 'add-hospital'})
      },

      onAddAnother() {
        this.showOverlay = false
        this.model = {country: '', hospital: ''}
        this.getAssignedHospitals()
      },

      onAllDone() {
        this.showOverlay = false
        this.$router.push({name: 'Overview'})
      },

      onUnassociate(hospital) {
        this.unassignHospital = hospital
        this.showConfirm = true
      },

      onConfirm() {
        this.showConfirm = false
        if (this.unassignHospital) {
          removeHospitalFromSurgeon({
            userId: this.authUser.id,
            hospitalId: this.unassignHospital.id
          }).then(() => {
            this.unassignHospital = {}
            this.getAssignedHospitals()
          })
        }
      },

      onCancel() {
        this.showConfirm = false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'

  .associate-hospital
    font-weight: bold
    font-family: 'Stolzl'

    .unassociate-title
      margin: 35px 0 25px 0

    .unassociate-item
      width: 100%
      display: flex
      font-size: 14px
      margin-bottom: 10px
      margin-top: 10px
      margin-left: 20px
      padding-bottom: 15px
      color: $color-text-invert

      span:nth-of-type(1)
        width: 80%
        font-weight: $font-medium

      .sprite
        width: 20px
        height: 20px
        fill: $color-error
        cursor: pointer

    .hospital-lookup-form
      width: 100%
      max-width: 1200px
      border-radius: 20px

      /deep/ .btn
        font-weight: normal
        font-family: 'Stolzl'
        border-radius: 5px
        &.is-secondary
          border: 1px solid $color-text

      /deep/ h3
        font-size: large
        text-transform: none

      /deep/ .input-wrapper
        .input-label
          font-size: 14px

      /deep/ .dropdown__relative-wrapper
        .dropdown
          &.scrollable
            max-height: 196px
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/AssociateHospital_v2.vue